import * as React from "react";

/** `text` with each `{{name}}` placeholder set in `<code>`. */
export function highlightVariables(text: string): React.ReactElement {
  // The placeholder the server substitutes, as `buildRequestTemplate` reads
  // it; anything else in braces is plain text. Captured whole, so `split`
  // alternates plain runs and placeholders and every odd index is one.
  const parts = text.split(/(\{\{\s*[a-zA-Z_][a-zA-Z0-9_.]*\s*\}\})/);
  return (
    <>
      {parts.map((part, index) => {
        if (part === "") {
          return null;
        }
        return index % 2 === 1 ? (
          <code key={index}>{part}</code>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        );
      })}
    </>
  );
}
